import { useMemo } from 'react';
import moment from 'moment';
import { SingleDatePickerWithCollapsibleCalendar } from 'ui/datePicker';

import { useProcessDatePickerValue } from './hooks/useProcessDatePickerValue';
import { useConditionValueWatch } from '../../../hooks/form';
import { AbsoluteDateValue } from '../../../domain';

export const DateSelect = () => {
  const defaultValue = useConditionValueWatch();
  const date = useMemo(
    () =>
      defaultValue instanceof AbsoluteDateValue
        ? moment(defaultValue.value)
        : (defaultValue?.value.toString() ?? ''),
    [defaultValue],
  );
  const processDatePickerValue = useProcessDatePickerValue();

  return (
    <SingleDatePickerWithCollapsibleCalendar
      showTime
      date={date}
      onDateChange={processDatePickerValue}
      canClearDate={false}
    />
  );
};
